import {DataStatus} from 'platform/components';

import {isNotNil} from 'ramda';

import {useGetWhatsAppConnectionQuery} from '@dms/api/settings';

import {WhatsAppConnect} from '../WhatsAppConnect/WhatsAppConnect';
import {WhatsAppConnectionStatus} from '../WhatsAppConnectionStatus/WhatsAppConnectionStatus';

export function WhatsAppConnection() {
  const {data: connection, isLoading, isError} = useGetWhatsAppConnectionQuery();

  return (
    <DataStatus isLoading={isLoading} isError={isError}>
      {isNotNil(connection) && connection.configurationState !== 'not_configured' ? (
        <WhatsAppConnectionStatus connection={connection} />
      ) : (
        <WhatsAppConnect />
      )}
    </DataStatus>
  );
}
